import { useContext } from "react";
import { KnopClientContext, KnopClientContextProps } from "./KnopClientContext";

export function useKnopClient(): KnopClientContextProps {
  const context = useContext(KnopClientContext);
  if (!context) {
    throw new Error("useKnopClient must be used within a KnopClientProvider");
  }
  return context;
}
